<template>
    <div>
        <p v-html="thanksMessage"></p>
        <transition name="fade">
            <div>
                <h2 class="subTitle" v-if="registrationDone">Thank you for registering.</h2>
                <p v-if="registrationDone">You can <a :href="siteUrl + 'account/login.php'">click here</a> to login into your account.</p>
            </div>
        </transition>
        <h2 class="subTitle" v-if="!registrationDone && !accountExist">Register and you can access your free sample from your account.</h2>
        <transition name="fade">
            <CheckoutErrorMessages :errors="errors" v-if="errors" />
        </transition>
        <transition name="fade">
        <div class="formBlock formBlockDouble" v-if="!registrationDone && !accountExist">
            <div class="formRow container">
                <div class="col col-2">
                    <label class="formLabel">*Password</label>
                    <input type="text" placeholder="*Password" class="formText" 
                    v-model="SelectedDataChild.password"
                    @input="$emit('updateSampleData', SelectedDataChild)" />
                </div>
                <div class="col col-2">
                    <label class="formLabel">*Confirm Password</label>
                    <input type="text" placeholder="*Confirm Password" class="formText" 
                    v-model="SelectedDataChild.confirmPassword"
                    @input="$emit('updateSampleData', SelectedDataChild)" />
                </div>
            </div>
            <div class="formRow container">
                <div class="col">
                    <input type="submit" value="Register" class="button button-blue" 
                    @click="register()" />
                    <div class="trustedsite-trustmark" style="vertical-align:middle;" data-type="211" data-width="120" data-height="50"></div>
                    <!-- End McAfee SECURE Engagement Trustmark for proofreadingpal.com -->
                </div>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import CheckoutErrorMessages from '@/components/CheckoutErrorMessages.vue';
export default {
    components: {
        CheckoutErrorMessages,
    },
    props: {
        SelectedData: Object,
    },
    data: function() {
        return {
            SelectedDataChild: this.SelectedData,
            errors: false,
            registrationDone: false,
            accountExist: true,
        }
    },
    computed: {
        thanksMessage: function () {
            if(this.SelectedDataChild.finalStatus == 'pending') {
                return 'Your free sample has been received. However, your free sample has been flagged as pending because your free sample matches criteria of an already existing free sample in our system. We\'ll notify you if we are unable to process this free sample. Otherwise, we\'ll have your free sample back within the next 36 hours.';
            }
            return 'You\'ll receive an email to access your free sample within the next '+this.SelectedDataChild.finalTurnaround+'.<br/> Two professional proofreaders will review your document!';
        }
    },
    mounted: function() {
        this.$nextTick(function() {
            this.$emit('loaded', true);
        });
        this.ifAccountExist();
    },
    created: function() {
        window.gtag('event', 'order', {
        'event_category': 'freesample',
        'event_label': 'freesample',
        'value': 1
        });
        if(typeof dataLayer != 'undefined'){
            window.dataLayer.push({
            'event': 'freesample'
            });
        }
        
    },
    methods: {
        ifAccountExist() {
            const formData = new FormData();
            formData.append('email', this.SelectedDataChild.email);
            return axios
                .post(this.siteUrl + 'include/API/ifAccountExist.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    console.log(response.data);
                    if(response.data.status == 'not exist') {
                        
                        this.accountExist = false;
                    } else {
                        this.accountExist = true;
                    }
                });
        },
        register() {
            this.errors = false;
            const data = this.SelectedDataChild;
            const errors = [];
            if(!data.password) {
                errors.push('Password');
            } else if(data.password != data.confirmPassword) {
                errors.push('Password Doesn\'t Match');
            }
            if(errors.length) {
                this.errors = errors;
                window.scrollTo(0, 0);
                return false;
            } 
            const formData = new FormData();
            formData.append('email', this.SelectedDataChild.email);
            formData.append('password', this.SelectedDataChild.password);
            formData.append('phone', this.SelectedDataChild.phone);
            formData.append('country', this.SelectedDataChild.country);
            formData.append('firstName', this.SelectedDataChild.firstName);
            formData.append('lastName', this.SelectedDataChild.lastName);
            return axios
                .post(this.siteUrl + 'include/API/registerAfterFreeSample.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    console.log(response.data);
                    if(response.data.status == 'success') {
                        this.registrationDone = true;
                    }
                });
        }
    }
}
</script>